<template>
  <div class="c-container ui-h-full">
    <div class="c-row c-center ui-h-full">
      <div class="c-col-full sm:c-col-4 md:c-col-8 lg:c-col-6">
        <div class="ui-relative c-bg-white ui-rounded-md">
          <!-- Content -->
          <div class="c-row ui-p-6">
            <div class="c-col-full">
              <!-- Estado de Loading  -->
              <div
                v-if="loading"
              >
                <p class="c-text-b1 c-text-center">
                  Excluindo e-mail...
                </p>
                <p class="c-text-b2 ui-mt-2 ui-text-gray-600 c-text-center">
                  Aguarde enquanto processamos sua solicitação.
                </p>
              </div>

              <!-- Estado Normal (Confirmação) -->
              <div
                v-else
                class="ui-mb-6"
              >
                <p class="c-text-b1">
                  Tem certeza que deseja excluir o e-mail <strong>{{ email.email }}</strong>?
                </p>
                <p class="c-text-b2 ui-mt-2 ui-text-gray-600">
                  Esta ação não pode ser desfeita.
                </p>
              </div>

              <!-- Buttons -->
              <div class="c-d-flex c-justify-end ui-space-x-3">
                <!-- Botão Cancelar - sempre visível -->
                <c-button
                  v-if="!loading"
                  outline
                  @click="$modal.hide()"
                  data-cy="cancelDeleteEmailButton"
                >
                  Cancelar
                </c-button>

                <!-- Botão Excluir - apenas no estado normal -->
                <c-button
                  v-if="!loading"
                  danger
                  @click="handleDelete"
                  data-cy="confirmDeleteEmailButton"
                >
                  Excluir
                </c-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CButton } from '@estrategiahq/coruja-web-ui';

export default {
  name: 'DeleteEmailModal',
  components: {
    CButton,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async handleDelete() {
      this.loading = true;

      try {
        await this.$services.accounts.deleteCommunicationEmail(this.email.id);

        this.$emit('email-deleted', this.email);

        setTimeout(() => {
          this.$modal.hide();
        }, 500);

      } catch (error) {
        this.$toast.show({
          type: 'error',
          text: error.message,
          timeout: 3000,
        });

        this.$modal.hide();
      }
    },
  },
};
</script>
